{
  "familyId": "TGL-TIJD-CONVERSIE",
  "questions": [
    {
      "id": "TGL-TIJD-CONVERSIE-001",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "Op de analoge klok is het kwart over 3. Hoe schrijf je dit digitaal?",
      "options": [
        "15:15",
        "03:15",
        "15:45",
        "03:45"
      ],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_quarter_afternoon",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 15,
            "minutes": 15
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Analoog naar digitaal 's middags",
            "content": "Kwart over 3 's middags = 3:15 + 12 uur = 15:15. Bij tijden 's middags tel je altijd 12 uur bij het gewone uur. Kwart over betekent :15."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij tijden 's middags tel je 12 uur bij het gewone uur, en vertaal 'kwart over' naar :15. Stap 1: kwart over 3 's middags → uur = 3 + 12 = 15. Stap 2: kwart over = :15. Stap 3: antwoord = 15:15.",
        "distractorExplanations": {
          "0": "Correct! Kwart over 3 's middags = 3 + 12 = 15, en kwart over = :15, dus 15:15.",
          "1": "Veelgemaakte fout: vergeten 12 uur bij te tellen. 03:15 is kwart over 3 's ochtends. Voor 's middags: 3 + 12 = 15, dus 15:15.",
          "2": "Veelgemaakte fout: kwart over en kwart voor verwarren. Kwart over = :15 (15 minuten na het hele uur). Kwart voor = :45 (15 minuten vóór het volgende uur). 15:45 is kwart voor 4.",
          "3": "Veelgemaakte fout: twee fouten tegelijk — vergeten 12 bij te tellen én kwart over/voor verwarren. 03:45 = kwart voor 4 's ochtends. Kwart over 3 's middags = 15:15."
        }
      }
    },
    {
      "id": "TGL-TIJD-CONVERSIE-002",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "De digitale klok toont 19:30. Hoe laat is het op een analoge klok?",
      "options": [
        "half 8 's avonds",
        "half 7 's avonds",
        "half 8 's ochtends",
        "8 uur 's avonds"
      ],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_half_evening",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 19,
            "minutes": 30
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Digitaal naar analoog 's avonds",
            "content": "19:30 betekent 19 - 12 = 7:30. Bij :30 (half) kijk je naar het volgende uur. 7:30 = half 8 's avonds. Trek altijd 12 af van tijden boven 12:00."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: trek 12 af van tijden boven 12:00 en vertaal de minuten naar 'half/kwart'. Stap 1: 19 − 12 = 7, dus het is 7 uur 's avonds. Stap 2: :30 = half uur. Stap 3: bij 'half' kijk je naar het volgende uur: 7:30 = half 8 's avonds.",
        "distractorExplanations": {
          "0": "Correct! 19:30 = 19 − 12 = 7:30, en bij 'half' kijk je naar het volgende uur, dus half 8 's avonds.",
          "1": "Veelgemaakte fout: 'half' verkeerd vertalen. Bij 'half' kijk je naar het volgende uur, niet het huidige. 7:30 = half 8 (een half uur vóór 8), niet half 7.",
          "2": "Veelgemaakte fout: 's avonds en 's ochtends verwarren. Tijden boven 12:00 zijn altijd 's middags of 's avonds. 19:30 = 7:30 's avonds, niet 's ochtends.",
          "3": "Veelgemaakte fout: de minuten negeren. :30 betekent half uur (30 minuten). 19:30 is niet 8 uur precies, maar half 8 's avonds."
        }
      }
    },
    {
      "id": "TGL-TIJD-CONVERSIE-003",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "Op de analoge klok is het 10 over 9 's ochtends. Hoe schrijf je dit digitaal?",
      "options": [
        "09:10",
        "21:10",
        "09:50",
        "10:09"
      ],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_minutes_morning",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 9,
            "minutes": 10
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Minuten omzetten 's ochtends",
            "content": "10 over 9 's ochtends = 9:10. 's Ochtends hoef je geen 12 bij te tellen. Schrijf het uur eerst (09), dan de minuten (:10)."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: schrijf het uur eerst, dan de minuten. 's Ochtends hoef je geen 12 bij te tellen. Stap 1: het uur is 9 → schrijf 09. Stap 2: 10 over = 10 minuten → schrijf :10. Stap 3: antwoord = 09:10.",
        "distractorExplanations": {
          "0": "Correct! 10 over 9 's ochtends = 09:10 (uur eerst, dan minuten).",
          "1": "Veelgemaakte fout: 12 uur bijtellen terwijl het 's ochtends is. 21:10 = 9:10 's avonds. De vraag gaat over 's ochtends, dus 09:10.",
          "2": "Veelgemaakte fout: 'over' en 'voor' verwarren. 10 over = :10 (10 minuten ná het hele uur). 09:50 = 10 voor 10 (10 minuten vóór het volgende uur).",
          "3": "Veelgemaakte fout: uur en minuten omdraaien. Digitaal schrijf je altijd eerst het uur, dan de minuten: 09:10, niet 10:09."
        }
      }
    },
    {
      "id": "TGL-TIJD-CONVERSIE-004",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "De digitale klok toont 16:45. Hoe laat is het op een analoge klok?",
      "options": [
        "kwart voor 5 's middags",
        "kwart over 4 's middags",
        "kwart voor 4 's middags",
        "kwart over 5 's middags"
      ],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_quarter_to",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 16,
            "minutes": 45
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kwart voor omzetten",
            "content": "16:45 betekent 16 - 12 = 4:45. Bij :45 (kwart voor) kijk je naar het volgende uur. 4:45 = kwart voor 5 's middags."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: trek 12 af van tijden boven 12:00 en vertaal :45 naar 'kwart voor'. Stap 1: 16 − 12 = 4, dus het is 4 uur 's middags. Stap 2: :45 = kwart voor. Stap 3: bij 'kwart voor' kijk je naar het volgende uur: 4:45 = kwart voor 5 's middags.",
        "distractorExplanations": {
          "0": "Correct! 16:45 = 4:45 's middags = kwart voor 5 's middags.",
          "1": "Veelgemaakte fout: kwart over en kwart voor verwarren. :45 = kwart voor (45 minuten), :15 = kwart over (15 minuten). 16:45 is kwart voor 5, niet kwart over 4.",
          "2": "Veelgemaakte fout: 'kwart voor' verkeerd vertalen. Bij 'kwart voor' kijk je naar het volgende uur. 4:45 = kwart voor 5, niet kwart voor 4.",
          "3": "Veelgemaakte fout: kwart over en kwart voor omdraaien. :45 = kwart voor het volgende uur, :15 = kwart over het huidige uur. 16:45 = kwart voor 5, niet kwart over 5."
        }
      }
    },
    {
      "id": "TGL-TIJD-CONVERSIE-005",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "Op de analoge klok is het 5 voor half 7 's avonds. Hoe schrijf je dit digitaal?",
      "options": [
        "18:25",
        "18:35",
        "06:25",
        "19:25"
      ],
      "correctAnswer": 0,
      "conceptId": "analog_to_digital_before_half",
      "variantIndex": 5,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 18,
            "minutes": 25
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Voor half omrekenen",
            "content": "Half 7 = 6:30. Vijf voor half 7 = 6:30 - 5 minuten = 6:25. 's Avonds tel je 12 bij: 6 + 12 = 18. Dus 18:25."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: vertaal 'voor half' stap voor stap. Stap 1: half 7 = 6:30. Stap 2: vijf voor half 7 = 6:30 − 5 minuten = 6:25. Stap 3: 's avonds tel je 12 bij: 6 + 12 = 18. Stap 4: antwoord = 18:25.",
        "distractorExplanations": {
          "0": "Correct! Half 7 = 6:30, vijf voor = −5 minuten = 6:25, en 's avonds + 12 = 18:25.",
          "1": "Veelgemaakte fout: 'voor' en 'over' half verwarren. 5 voor half = 5 minuten eerder dan half (6:30 − 5 = 6:25). 5 over half = 5 minuten later (6:30 + 5 = 6:35).",
          "2": "Veelgemaakte fout: vergeten 12 bij te tellen voor 's avonds. 06:25 is 's ochtends. Voor 's avonds: 6 + 12 = 18, dus 18:25.",
          "3": "Veelgemaakte fout: 'half 7' verwarren met 7:30. Half 7 = 6:30 (een half uur vóór 7), niet 7:30. Vijf voor half 7 = 6:25, niet 7:25. 's Avonds: 18:25."
        }
      }
    },
    {
      "id": "TGL-TIJD-CONVERSIE-006",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "multiple_choice",
      "question": "De digitale klok toont 11:20. Hoe laat is het op een analoge klok?",
      "options": [
        "20 over 11",
        "10 voor half 12",
        "20 voor 12",
        "11 uur 's avonds"
      ],
      "correctAnswer": 0,
      "conceptId": "digital_to_analog_twenty",
      "variantIndex": 6,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hours": 11,
            "minutes": 20
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Minuten aflezen",
            "content": "11:20 betekent 11 uur en 20 minuten. Dat zeg je als '20 over 11'. Je kunt ook zeggen '10 voor half 12' (want half 12 = 11:30, en 11:20 is 10 minuten eerder)."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: vertaal de digitale tijd naar woorden. Stap 1: 11:20 = 11 uur en 20 minuten. Stap 2: 20 minuten na het hele uur = '20 over 11'. (Je kunt ook zeggen '10 voor half 12', want half 12 = 11:30, en 11:30 − 10 = 11:20.)",
        "distractorExplanations": {
          "0": "Correct! 11:20 = 20 over 11 (11 uur en 20 minuten).",
          "1": "Veelgemaakte fout: dit klopt ook! Half 12 = 11:30, en 11:20 is inderdaad 10 minuten voor half 12. Maar '20 over 11' is het meest directe antwoord.",
          "2": "Veelgemaakte fout: 'over' en 'voor' verwarren. 20 voor 12 = 11:40 (12:00 − 20 minuten). 11:20 = 20 over 11 (11:00 + 20 minuten).",
          "3": "Veelgemaakte fout: de minuten negeren. 11:20 is niet 11 uur precies — er staan 20 minuten achter de dubbele punt."
        }
      }
    },
    {
      "id": "TGL-TIJD-CONVERSIE-007",
      "familyId": "TGL-TIJD-CONVERSIE",
      "module": "TGL",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_conversie",
      "questionType": "matching",
      "question": "Koppel de analoge tijden aan de digitale tijden.",
      "options": [
        "Match 1",
        "Match 2",
        "Match 3",
        "Match 4"
      ],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Half drie", "Kwart over twee", "Kwart voor drie", "Drie uur"],
        "rightItems": ["14:30", "14:15", "14:45", "15:00"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "interactiveConfig": {
        "pairs": [
          {
            "left": "Half drie",
            "right": "14:30"
          },
          {
            "left": "Kwart over twee",
            "right": "14:15"
          },
          {
            "left": "Kwart voor drie",
            "right": "14:45"
          },
          {
            "left": "Drie uur",
            "right": "15:00"
          }
        ]
      },
      "conceptId": "time_analog_digital_matching",
      "variantIndex": 7,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {
            "hour": 3,
            "minute": 0
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tijden koppelen",
            "content": "Bij tijden 's middags tel je 12 bij: half drie = 2:30 + 12 = 14:30, kwart over twee = 2:15 + 12 = 14:15, kwart voor drie = 2:45 + 12 = 14:45, drie uur = 3:00 + 12 = 15:00."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bij tijden 's middags tel je 12 bij het gewone uur, en vertaal 'half/kwart' naar minuten. Stap 1: half drie = 2:30, 's middags + 12 = 14:30. Stap 2: kwart over twee = 2:15, 's middags + 12 = 14:15. Stap 3: kwart voor drie = 2:45, 's middags + 12 = 14:45. Stap 4: drie uur = 3:00, 's middags + 12 = 15:00."
      }
    }
  ]
}